import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PropertyInfo, ListingCardIndicator, LeftSidePropertyValue, linkPropType, listingPropType, } from '../listingCard/cardParts';
import { getAddressLine } from '../listingCard/cardHelpers';
import classnames from 'classnames/bind';
import cls from './styles.scss';
const cx = classnames.bind(cls);
const PopupAddress = ({ address, elmId }) => {
    return (_jsx("div", { "data-elm-id": `${elmId}_address_field`, className: cx('address-field', 'nowrap'), children: address }));
};
PopupAddress.propTypes = {
    address: PropTypes.string,
    elmId: PropTypes.string,
};
const CardImage = ({ listing, listingPhotoUrl, defaultPhotoUrl, className, }) => {
    const altTextImage = getAddressLine(listing.seller_property);
    return (_jsx("div", { className: cx('property-card-image-container', className), style: {
            backgroundImage: `url(${defaultPhotoUrl})`,
        }, children: _jsx("div", { className: cx('property-card-image-background'), style: {
                backgroundImage: `url(${listingPhotoUrl})`,
            }, role: 'img', "aria-label": altTextImage }) }));
};
CardImage.propTypes = {
    listing: listingPropType,
    listingPhotoUrl: PropTypes.string,
    defaultPhotoUrl: PropTypes.string,
    className: PropTypes.string,
};
export { PopupAddress, CardImage, LeftSidePropertyValue as PropertyValue, PropertyInfo, ListingCardIndicator as AuctionInfo, linkPropType, };
//# sourceMappingURL=cardParts.js.map